export enum ModuleActionViewEnum {
    Overview = 0, 
    Show = 1, 
    Add = 2,
    Edit = 3
}
